import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { DropdownMenuModule } from '@anecdotes/design-system/dropdown-menu';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { DataSortComponent, HeaderDataSortComponent, SortHeaderComponent, SortHeaderOptionComponent } from './components';
import { UtilsModule } from '@anecdotes/design-system/utils';

@NgModule({
  imports: [
    CommonModule,
    DropdownMenuModule,
    ButtonsModule,
    SvgIconsModule,
    TranslateModule,
    UtilsModule
  ],
  declarations: [
    DataSortComponent,
    HeaderDataSortComponent,
    SortHeaderComponent,
    SortHeaderOptionComponent
  ],
  exports: [
    DataSortComponent,
    HeaderDataSortComponent,
    SortHeaderComponent,
    SortHeaderOptionComponent
  ],
})
export class DataSortModule {}
